<template>
    <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="6" lg="4">
                <v-card elevation="8" class="pa-8" rounded="lg">
                    <div v-if="store.isLoggedIn" class="text-center">
                        <v-icon size="80" color="success" class="mb-4">mdi-check-circle</v-icon>
                        <h1 class="text-h4 mb-4">{{ $t('login.welcome_back') }}</h1>
                        <p class="text-body-1 text-medium-emphasis mb-6">{{ $t('login.you_are_logged_in') }}</p>
                        <v-btn
                            @click="onLogout()"
                            variant="tonal"
                            size="large"
                            prepend-icon="mdi-logout"
                            block
                        >
                            {{ $t('login.logout') }}
                        </v-btn>                        
                    </div>

                    <div v-else>
                        <div class="text-center mb-8">
                            <HeadIcon class="mb-4" width="120" />
                            <h1 class="text-h4 mb-2">{{ $t('login.welcome') }}</h1>
                            <p class="text-body-2 text-medium-emphasis">{{ $t('login.sign_in_or_create_an_account_with_google') }}</p>
                        </div>

                        <div class="d-flex justify-center mb-8">
                            <GoogleLogin
                                :callback="callback"
                                :button-config="{ text: 'continue_with' }"
                            />
                        </div>

                        <v-divider class="my-8"></v-divider>

                        <div v-if="isDevelopment">
                            <div class="text-center mb-4">
                                <p class="text-caption text-medium-emphasis">{{ $t('login.development_only') }}</p>
                                DEV Mode: {{ devMode }}
                            </div>

                            <v-btn
                                color="error"
                                @click="onFakeLogin()"
                                variant="outlined"
                                prepend-icon="mdi-account-circle"
                                block
                                class="mb-3"
                            >
                                {{ $t('login.login_as_fat_frumos') }}
                            </v-btn>

                            <v-btn
                                color="error"
                                @click="onFakeLogin2()"
                                variant="outlined"
                                prepend-icon="mdi-account-circle"
                                block
                                class="mb-3"
                            >
                                {{ $t('login.login_as_ileana_cosanzeana') }}
                            </v-btn>

                            <v-btn
                                color="warning"
                                @click="onFakeLogin3()"
                                variant="outlined"
                                prepend-icon="mdi-account"
                                block
                                class="mb-3"
                            >
                                {{ $t('login.login_as_zmeu') }}
                            </v-btn>

                            <v-btn
                                color="secondary"
                                @click="onFakeLogin4()"
                                variant="outlined"
                                prepend-icon="mdi-account-outline"
                                block
                                class="mb-3"
                            >
                                {{ $t('login.login_as_muma_padurii') }}
                            </v-btn>

                            <!-- <v-btn
                                variant="tonal"
                                size="large"
                                prepend-icon="mdi-logout"
                                block
                                @click="onLocalFakeLogin()"
                            >
                                Local fake login
                            </v-btn> -->

                            <v-divider class="my-4"></v-divider>

                            <!-- DEV: simulates Zmeu receiving an invite from Fât Frumos -->
                            <v-btn
                                color="info"
                                variant="outlined"
                                prepend-icon="mdi-link"
                                block
                                :to="{ path: '/login', query: { token: 'tok-fat-zmeu-002' } }"
                            >
                                Făt.Frumos→Zmeu
                            </v-btn>

                            <!-- <v-btn
                                color="warning"
                                @click="onClearCredentials()"
                                variant="outlined"
                                prepend-icon="mdi-account"
                                block
                            >
                                {{ $t('login.clear_credentials') }}
                            </v-btn> -->
                        </div>
                    </div>
                </v-card>
                <div class="text-center mt-4">
                    <span class="text-caption text-grey-lighten-1">
                        {{appTag}} · {{ appVersion }} · {{ appVersionDate }}
                    </span>
                </div>
            </v-col>
        </v-row>
    </v-container>

    <TermsModal v-model="showTermsModal" @accepted="onTermsAccepted" @declined="onTermsDeclined" />
</template>

<script>
import { appStore } from '@/stores/AppStore'
import apiService from '@/services/ApiService'
import envMixin from '@/mixins/envMixin'
import appVersionMixin from '@/mixins/appVersionMixin'
import HeadIcon from '@/components/public/HeadIcon.vue'
import TermsModal from '@/components/public/TermsModal.vue'

export default {
    name: 'LoginView',
    components: { HeadIcon, TermsModal },
    mixins: [envMixin, appVersionMixin],
    data() {
        return {
            showTermsModal: false,
            // Holds profileState from login response while user is reading the ToS modal,
            // so we know where to redirect after acceptance.
            pendingProfileState: null,
        };
    },
    computed: {
        store() {
            return appStore();
        },
        // isLoggedIn() {
        //     return this.store.isLoggedIn;
        // }
    },
    created() {
        // this.store.initAuth();
    },
    methods: {
        updateLanguage(newLang){
            // Save to local storage and update i18n
            localStorage.setItem('user-language', newLang);
            this.$i18n.locale = newLang;
        },

        //Step 1. This callback will be triggered when the user selects or login to
        // his Google account from the popup
        callback (response) {
            
            console.log("LoginView > callback > response", response)

            const api_url = process.env.VUE_APP_API_ENDPOINT;
            const google_url = `${api_url}/auth/google`;
            console.log("LoginView > callback > Google URL:", google_url);

            const invitationToken = this.$route.query.token || null; //invitation token

            // Step 2. Send the Google credential token to your backend
            fetch(google_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    token: response.credential ,
                    invitationToken
                })
                // body: JSON.stringify({ token: "nothing" })
            })

            //Step 3. Your backend will validate the token and return your own JWT token
            .then(res => res.json())

            // Step 4. Now we have response decoded as JSON. Save the token in your store (or localStorage)
            .then(data => {
                console.log('LoginView > callback > Backend response:', data);
                // Backend returns your own JWT token

                // appStore.setAuth(token, { email, name })

                this.store.login(data.token);
                this.store.setUser(data.user);
                apiService.token = data.token; //TODO: I do not like that I have to do it separatelly (maybe move into store?!?)
                this.updateLanguage(data.user.language)

                console.log("LoginView > callback > profileState:", data.user.profileState);
                if (!data.user.termsAcceptedAt) {
                    this.pendingProfileState = data.user.profileState;
                    this.showTermsModal = true;
                } else {
                    this.redirectByProfileState(data.user.profileState);
                }
                // No jwt-decode needed here
            })
            .catch(() => {
                this.$toast.error(this.$t('login.error_login_failed'));
            });
        },

        onLogout() {
            console.log("Logging out");
            this.store.logout();
            apiService.token = null;
        },

        // onLocalFakeLogin(){
        //     console.log("Local fake login");

        //     this.store.login('1234KnockKnock!');
        //     this.store.setUser('Chiar el');
        //     this.updateLanguage('ro')
        // },

        doFakeLogin(endpoint) {
            const url = `${process.env.VUE_APP_API_ENDPOINT}/auth/${endpoint}`;
            const invitationToken = this.$route.query.token || null;
            fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ invitationToken }),
            })
                .then(res => res.json())
                .then(data => {
                    this.store.login(data.token);
                    this.store.setUser(data.user);
                    this.updateLanguage(data.user.language);
                    console.log(`LoginView > ${endpoint} > profileState:`, data.user.profileState);
                    if (!data.user.termsAcceptedAt) {
                        this.pendingProfileState = data.user.profileState;
                        this.showTermsModal = true;
                    } else {
                        this.redirectByProfileState(data.user.profileState);
                    }
                });
        },


        // @param profileState {String} - 'T0', 'T1', or 'T2'
        redirectByProfileState(profileState) {
            this.$router.push(profileState === 'T2' ? '/matches' : '/me');
        },


        // Called when user accepts ToS in the modal. Updates store and redirects.
        onTermsAccepted() {
            const user = { ...this.store.getUser, termsAcceptedAt: new Date().toISOString() };
            this.store.setUser(user);
            this.showTermsModal = false;
            this.redirectByProfileState(this.pendingProfileState);
        },


        // Called when user explicitly declines ToS. Logs out and stays on login page.
        onTermsDeclined() {
            this.store.logout();
            this.showTermsModal = false;
            this.pendingProfileState = null;
        },


        onFakeLogin()  { this.doFakeLogin('fakeLogin');  }, // Fât Frumos (user_id=1, T2)
        onFakeLogin2() { this.doFakeLogin('fakeLogin2'); }, // Ileana Cosânzeana (user_id=2, T2)
        onFakeLogin3() { this.doFakeLogin('fakeLogin3'); }, // Zmeu (user_id=3, T1)
        onFakeLogin4() { this.doFakeLogin('fakeLogin4'); }, // Muma Pădurii (user_id=4, T0)

        // onClearCredentials(){
        //     this.store.reset();
        // }
    }
}
</script>

<style scoped>
.welcome {
    text-align: center;
    padding: 2rem;
}
</style>